import './login.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { Controls, validators } from 'shared/helper/form';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { sendPhoneOtpV2 } from '../actions';
import { recordSignInClick } from '../../helpers/gtm';
import useOtpLogin from './useOtpLogin';
import ProvidersV2 from './ProvidersV2';
var Form = Controls.Form,
  Text = Controls.Text,
  Password = Controls.Password;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty;
var defaultValues = {
  email: '',
  password: ''
};
function LogingV2(_ref) {
  var processing = _ref.processing,
    providers = _ref.providers,
    referringUrl = _ref.referringUrl,
    loginUser = _ref.loginUser,
    _ref$onUserLoginAttem = _ref.onUserLoginAttempt,
    onUserLoginAttempt = _ref$onUserLoginAttem === void 0 ? function () {} : _ref$onUserLoginAttem;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var dispatch = useDispatch();
  var newSendOTP = featureEnabled('send_otp_login_rubriq');
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var watch = methods.watch,
    getValues = methods.getValues;
  var chinaLocalization = useSelector(getChinaLocalization);
  var emailOrPhoneNumber = getValues('emailOrPhoneNumber');
  var loginValue = watch('emailOrPhoneNumber');
  var isNumeric = loginValue && /^[0-9]*$/.test(loginValue);
  var isEmailLogin = loginValue && !isNumeric;
  var _useOtpLogin = useOtpLogin({
      methods: methods,
      dispatch: dispatch,
      sendPhoneOtpV2: sendPhoneOtpV2,
      loginUser: loginUser,
      chinaLocalization: chinaLocalization,
      newSendOTP: newSendOTP,
      onUserLoginAttempt: onUserLoginAttempt
    }),
    showOtp = _useOtpLogin.showOtp,
    showResend = _useOtpLogin.showResend,
    otpTimer = _useOtpLogin.otpTimer,
    otpRefs = _useOtpLogin.otpRefs,
    handleSendOTP = _useOtpLogin.handleSendOTP,
    handleOtpChange = _useOtpLogin.handleOtpChange,
    handleOtpKeyDown = _useOtpLogin.handleOtpKeyDown,
    otpLoading = _useOtpLogin.otpLoading;
  var handleLoginUser = function handleLoginUser(user) {
    if (!chinaLocalization || chinaLocalization && !newSendOTP) {
      recordSignInClick({
        buttonId: 'login_button',
        buttonText: t('sign-in')
      });
      sessionStorage.setItem('rubriq_last_page', 'login');
      trackRubriqEvent('Login Attempted', {
        email_attempted: user.email,
        landing_page: window.location.pathname,
        device: navigator.userAgent
      });
      return loginUser(user).then(function (loggedInUser) {
        if (!(loggedInUser !== null && loggedInUser !== void 0 && loggedInUser.loggedIn)) {
          trackRubriqEvent('Login Failed', {
            reason: (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.error) || 'invalid_credentials',
            email_attempted: user.email,
            landing_page: window.location.pathname
          });
          return onUserLoginAttempt(loggedInUser);
        }
        sessionStorage.removeItem('rubriq_otp_dismissed');
        return onUserLoginAttempt(loggedInUser);
      }).catch(function (error) {
        trackRubriqEvent('Login Failed', {
          reason: (error === null || error === void 0 ? void 0 : error.message) || 'unknown',
          email_attempted: user.email,
          landing_page: window.location.pathname
        });
        throw error;
      });
    }
    var data = {
      email: user.emailOrPhoneNumber,
      password: user.password
    };
    if (!emailOrPhoneNumber) return Promise.resolve();
    if (isEmailLogin) {
      return loginUser(data).then(onUserLoginAttempt);
    }
    var phoneNumber = getValues('emailOrPhoneNumber');
    var loginData = {
      phoneNumber: phoneNumber
    };
    if (chinaLocalization && newSendOTP) {
      loginData.platform = 'rubriq';
      loginData.actionType = 'login';
      loginData.countryCode = '+86';
    }
    return handleSendOTP();
  };
  var watchedOtp = methods.watch('otp') || '';
  return /*#__PURE__*/React.createElement("div", {
    className: "new-login w-50 mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center w-75 mx-auto"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "sign-in"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 have-account"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/register"
  }, /*#__PURE__*/React.createElement(T, {
    source: "I don't have an account"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, !chinaLocalization || !newSendOTP ? /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handleLoginUser,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "work-personal-email",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: {
      wrapper: 'row m-0',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    ariaLabel: "work-personal-email"
  })), /*#__PURE__*/React.createElement(Password, {
    placeholder: "Password",
    messages: {
      notEmpty: 'Please enter your password.'
    },
    name: "password",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      wrapper: 'mb-0'
    }
  }), /*#__PURE__*/React.createElement("button", {
    id: "login_button",
    disabled: processing,
    type: "submit",
    className: "agree-button w-100",
    "aria-label": t('sign-in')
  }, processing && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "sign-in"
  })))) : /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handleLoginUser,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "Enter-your-email-or-mobile-number",
    messages: isEmailLogin ? {
      isEmail: 'emailAddressInvalidFormat'
    } : {
      notEmpty: 'Please enter your mobile number.'
    },
    name: "emailOrPhoneNumber",
    maxLength: isNumeric ? 11 : undefined,
    validators: isEmailLogin ? {
      isEmail: isEmail
    } : {
      notEmpty: notEmpty
    },
    styles: {
      wrapper: 'row m-0',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    ariaLabel: "Enter-your-email-or-mobile-number"
  })), showOtp && /*#__PURE__*/React.createElement("div", {
    className: "text-start otp-sent-info-rubriq"
  }, /*#__PURE__*/React.createElement(T, {
    source: "enter-6-digit-otp",
    className: "mb-2"
  })), isEmailLogin && /*#__PURE__*/React.createElement(Password, {
    placeholder: "Password",
    messages: {
      notEmpty: 'Please enter your password.'
    },
    name: "password",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      wrapper: 'mb-0'
    }
  }), showOtp && /*#__PURE__*/React.createElement("div", {
    className: "otp-row"
  }, [0, 1, 2, 3, 4, 5].map(function (i) {
    return /*#__PURE__*/React.createElement("input", {
      key: i,
      type: "text",
      inputMode: "numeric",
      maxLength: 1,
      className: "otp-box",
      ref: function ref(el) {
        otpRefs.current[i] = el;
      },
      value: watchedOtp[i] || '',
      onChange: function onChange(e) {
        return handleOtpChange(e.target.value, i);
      },
      onKeyDown: function onKeyDown(e) {
        return handleOtpKeyDown(e, i);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "otp-wrapper"
  }, showResend && /*#__PURE__*/React.createElement("div", {
    className: otpTimer > 0 ? 'resend-otp-disabled' : 'resend-otp'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleSendOTP,
    className: "otp-wrapper"
  }, /*#__PURE__*/React.createElement(T, {
    source: "".concat(otpTimer !== 0 ? 'resend otp' : 'resend')
  })), otpTimer !== 0 && /*#__PURE__*/React.createElement("span", {
    className: "count ps-1"
  }, otpTimer, "s")))), chinaLocalization && newSendOTP && !showOtp && /*#__PURE__*/React.createElement("button", {
    id: "login_button",
    disabled: processing || otpLoading,
    type: "submit",
    className: "agree-button w-100 d-flex justify-content-center align-items-center",
    "aria-label": t('sign-in')
  }, /*#__PURE__*/React.createElement(T, {
    source: "sign-in"
  }), (processing || otpLoading) && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true,
    className: "ms-2"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "my-4 text-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login/forgot-password"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mx-3 forgot text-underline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Can't sign in?"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center my-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-3 split"
  }, /*#__PURE__*/React.createElement(T, {
    source: "or"
  })), /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }))), /*#__PURE__*/React.createElement(ProvidersV2, {
    providers: providers,
    referringUrl: referringUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms my-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "privacy-policy"
  })), /*#__PURE__*/React.createElement("p", {
    className: "terms my-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "terms-and-conditions"
  }))))));
}
export default LogingV2;